import { $convertFromMarkdownString, TRANSFORMERS } from '@lexical/markdown';

const $populateMarkdown = (markdown: string) => {
  $convertFromMarkdownString(
    markdown,
    TRANSFORMERS,
    undefined,
    true /* shouldPreserveNewLines */,
    true /* shouldMergeAdjacentLines */
  );
};

export default $populateMarkdown;
